import { render } from "./ButtonActionRender.vue?vue&type=template&id=02b5b47a"
import script from "./ButtonActionRender.vue?vue&type=script&lang=js"
export * from "./ButtonActionRender.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__